/* eslint-disable no-console */
import {store} from '../components/store'

export const auth = {
    data: function () {
        return {
            userInfo:store.state
        }
    },
    methods: {
        persist(obj) {
            localStorage.user=JSON.stringify(obj);
        },
        save2store(obj){
            store.login(obj);
        },
        logout(){
            store.logout();
            localStorage.removeItem('user');
            this.$router.push({path:'/login',replace:true});
        },
        updateInfo(obj){
            store.login(obj);
        }
    },
    watch:{
        userInfo:function(newState){
            console.log("persist!");
            this.persist(newState);
        }
    },
    computed:{
        header(){
            return `${this.userInfo.phone} ${this.userInfo.password}`;
        }
    },
    mounted(){
        console.log("mixin!");

        if(store.state.phone !== "" && store.state.password !== ""){
            console.log("data in store");
        }else{
            if(localStorage.user){
                console.log("data in localStorage");
                this.save2store(JSON.parse(localStorage.user));
            }else{
                this.logout();
            }
        }
    }
}